var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as S from './style';
import Lottie from 'lottie-web';
import IdealState from '../../../../json/splashverse-onboarding/personalize-opt-in/ideal-state.json';
import { PersonalizeOptIn } from '../../../constant-data/splashverse-onboarding';
import { getItemFromLocalStorage, sendEventUsingAvo } from '../../../utils/web-helper';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { savePersonalisationIntent } from '../../../services/parent-api';
import { appendBaseParams } from '../../../utils/avo-helper';
export var PersonalizeOptInScreen = function (props) {
    var _a = useExtendedLocalStorage('splashverse-onboarding'), getItem = _a.getItem, setValue = _a.setValue;
    useEffect(function () {
        var _a, _b, _c, _d;
        Lottie.loadAnimation({
            container: document.getElementById('personalize-opt-in-wrapper'),
            animationData: IdealState,
            loop: true,
            renderer: 'svg',
            name: 'personalizeOptIn',
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice', // Supports the same options as the svg element's
            }
        });
        sendEventUsingAvo({ methodName: 'viewedCoqOptInScreen', params: __assign({}, appendBaseParams({
                signupFlow: (_a = props.students[0]) === null || _a === void 0 ? void 0 : _a.signup_flow,
                mathGrade: (_b = props.students[0]) === null || _b === void 0 ? void 0 : _b.grade_code,
                elaGrade: (_c = props.students[0]) === null || _c === void 0 ? void 0 : _c.grade_code,
                grade: (_d = props.students[0]) === null || _d === void 0 ? void 0 : _d.grade_code
            })) });
    }, []);
    var onClickHandler = function (code, animationData) { return __awaiter(void 0, void 0, void 0, function () {
        var animationContainer;
        return __generator(this, function (_a) {
            Lottie.destroy('personalizeOptIn');
            animationContainer = Lottie.loadAnimation({
                container: document.getElementById('personalize-opt-in-wrapper'),
                animationData: animationData,
                loop: false,
                renderer: 'svg',
                name: code,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice', // Supports the same options as the svg element's
                }
            });
            animationContainer.addEventListener('complete', function () { return onClickHandlerSuccessCallback(code); });
            return [2 /*return*/];
        });
    }); };
    var onClickHandlerSuccessCallback = function (code) {
        var _a, _b, _c, _d;
        var selectedSubject = getItem("selectedSubject");
        var isUserSkips = false;
        /// to filter plan on new plan page
        if (code == "no_skip") {
            isUserSkips = true;
        }
        setValue("selectedPersonalize", code);
        sendEventUsingAvo({
            methodName: 'interactedCoqOptInScreen',
            params: __assign({ 'clickedOn': isUserSkips ? 'No' : 'Yes' }, appendBaseParams({
                signupFlow: (_a = props.students[0]) === null || _a === void 0 ? void 0 : _a.signup_flow,
                mathGrade: (_b = props.students[0]) === null || _b === void 0 ? void 0 : _b.grade_code,
                elaGrade: (_c = props.students[0]) === null || _c === void 0 ? void 0 : _c.grade_code,
                grade: (_d = props.students[0]) === null || _d === void 0 ? void 0 : _d.grade_code
            }))
        });
        var params = { "personalization_intent": !isUserSkips };
        savePersonalisationIntent(params);
        var opt = {
            code: code,
            selectedSubject: selectedSubject
        };
        props.goToNextHandler('personalize_opt_in_screen', opt);
    };
    var childName = getItemFromLocalStorage('tutoringChildName');
    return (_jsxs(_Fragment, { children: [_jsxs(S.Heading, { children: ["Do you want to personalize ", childName, "'s Learning Path"] }), _jsx(S.FloatingWrapper, __assign({ id: "personalize-opt-in-wrapper" }, { children: PersonalizeOptIn.map(function (val) {
                    return _jsx(S.OpaqueCta, { left: val.left, top: val.top, onClick: function (e) { return onClickHandler(val.code, val.selectAnimation); } });
                }) })), _jsx(S.Footer, { children: "Providing this information helps us pick content that's just right" })] }));
};
export default React.memo(PersonalizeOptInScreen);
